import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierWatchControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelOnboarding: Label;
    labelSftpServer: Label;
    panel2: Panel;
    panel3: Panel;
    panelServer: Panel;
    sourceCarrierInsControl: DataSource;
    switchBasicMonitoring: Switch;
    switchEnableAdvances: Switch;
    switchIsActive: Switch;
    switchMonitorCarriers: Switch;
    switchSendCarriers: Switch;
    textboxAccountId: Textbox;
    textboxAccountPassword: Textbox;
    textboxAccountType: Textbox;
    textboxCarrierStatus: Textbox;
    textboxFtpPassword: Textbox;
    textboxFtpPort: Textbox;
    textboxFtpServer: Textbox;
    textboxFtpUserId: Textbox;
    textboxLastFullSyncDate: Textbox;
    textboxLastSyncDate: Textbox;
    textboxOnboardingServer: Textbox;
    textboxRemoteDirectory: Textbox;
    textboxServer: Textbox;
    textboxUnloadFile: Textbox;
}
